import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DynamicDialogConfig, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { constants } from '../../../../shared/constants/constants';
import { PipesModule } from '../../../../shared/pipes/pipes.module';
@Component({
  selector: 'app-role-ended-modal',
  standalone: true,
  imports: [ButtonModule, RadioButtonModule, DynamicDialogModule, PipesModule],
  templateUrl: './role-ended-modal.component.html',
  styleUrl: './role-ended-modal.component.scss'
})
export class RoleEndedModalComponent implements OnInit {
  roleEndedInfo: any = {
    position: {},
    project: {},
    role: {}
  }
  presumptiveStatus = constants.presumptiveStatus;
  firmName ='';
  reasonTitle = '';
  endMessage = '';
  roleStarted = false;
  hasTsheet = false;
  gotoInvoiceText = 'Go To Timesheet';
  constructor(private roleEndedModalRef: DynamicDialogRef, public config: DynamicDialogConfig) { }

  ngOnInit(): void {
    this.roleEndedInfo = this.config.data;
    this.firmName = this.roleEndedInfo.position.firm && this.roleEndedInfo.position.firm.name || ''
    this.reasonTitle = `Message from ${this.firmName}`;
    this.roleStarted = this.roleEndedInfo.role.isStarted;
    this.hasTsheet = this.roleEndedInfo.position.tsheets && !!this.roleEndedInfo.position.tsheets.isEnabled;
    this.reasonTitle = `Message from ${this.roleEndedInfo.position.firm && this.roleEndedInfo.position.firm.name || ''}`;
    this.endMessage = this.roleEndedInfo.position.endMessage || '';
    if(this.hasTsheet && this.roleEndedInfo.position.presumptive){
      this.hasTsheet = (this.roleEndedInfo.position.presumptive.status !== this.presumptiveStatus.DENIED && this.roleEndedInfo.position.presumptive.status !== this.presumptiveStatus.ASSIGNED) || false;
    }
    if(this.roleEndedInfo.project.contractorTimekeepingEnabled){
      this.gotoInvoiceText = 'Review Timekeeping Records';
    }
  }

  confirm(isConfirm: boolean) {
    this.roleEndedModalRef.close(isConfirm);
  }
}